import { FormControl } from '@angular/forms';

export function NoWhitespaceValidator(control: FormControl) {
    return /\s/g.test(control.value) ? { 'whitespace': true } : null;
}